// Variables for common colors -----------------------------
export const colors = {
  white: "#FFFFFF",
  black: "#000000",
  grey400: "#BDBDBD",
  grey500: "#888888",
  grey600: "#646464",
  grey800: "#424242",
  grey900: "#212121",
};
